module.exports = __webpack_public_path__ + "Pinolo-gQa.jpg";